"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ForwardThumbnail;

var _react = _interopRequireWildcard(require("react"));

var _PWAContext = _interopRequireDefault(require("./PWAContext"));

/**
 * Wrap product links in this component to reuse the thumbnail as the main image in the product
 * skeleton when transitioning to the PDP to make the transition feel instant. This component
 * sets the `thumbnail` ref on the provided `PWAContext` to the `src` prop of the first `img`
 * element found amongst the descendant elements in the tree.
 *
 * Example:
 *
 * ```js
 *  <ForwardThumbnail>
 *    <Link href="/p/[productId]" as={product.url}>
 *      <a>
 *        <Image src={product.media.thumbnail.src} alt={product.media.thumbnail.alt} />
 *        <div>{product.name}</div>
 *      </a>
 *    </Link>
 *  </ForwardThumbnail>
 * ```
 */
function ForwardThumbnail(_ref) {
  var children = _ref.children;
  var ref = (0, _react.useRef)(null);
  var context = (0, _react.useContext)(_PWAContext["default"]);
  var srcRef = (0, _react.useRef)(null);
  var setSrcRef = (0, _react.useCallback)(function () {
    if (ref.current.querySelector('img')) {
      srcRef.current = ref.current.querySelector('img').getAttribute('src');
    }
  }, []);
  (0, _react.useEffect)(setSrcRef, [children]);
  var handleClick = (0, _react.useCallback)(function () {
    if (!srcRef.current) {
      setSrcRef();
    }

    context.thumbnail.current = {
      src: srcRef.current
    };
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: ref,
    onClick: handleClick
  }, children);
}
